// extracted by mini-css-extract-plugin
export default {"sectionTitle":"ActionItems_sectionTitle__sqHbz","grid":"ActionItems_grid__oJlX9"};